import React, { useState, useRef, useEffect } from "react";
import useClickOutside from "../../../../components/Custom_Hooks/useClickOutsSide";
import { useDispatch, useSelector } from "react-redux";
import {
  closeModal,
  contraVoucherCreate,
  openModal,
  serialNumberList,
} from "../../../../redux/actions/action-creator";
import { useInputActionVoucher } from "../../../../components/Custom_Hooks/useInputActionVoucher";
import InputField from "../../../../components/Input/InputField";
import DropdownLayout_1 from "../../../../components/Dropdown/DropdownLayout_1";
import {
  prepareFormData,
  useFormHandler,
} from "../../../../components/Custom_Hooks/useFormHandler";
import Form from "../../../../components/Form/Form";
import MasterCreationFooter from "../../../../components/Footer/Master_Footer/MasterCreationFooter";
import { VoucherContraInputRow } from "./VoucherContraInputRow";
import {
  currencyFormate,
  getDateInFormate,
} from "../../../../components/Date_Formate_Utilitiy/Index";
import { flushSync } from "react-dom";
import Total_Amount_Row from "../../../../components/Total_Amount/Total_Amount_Row";
import TableHeader from "../../../../components/Table/TableHeader";

const Contra = ({
  loading_voucher,
  data,
  setData,
  contra_account_ledger_list,
  handleChange,
  handleBlur,
  handleFocus,
  handleKeyDown,
  handleKeyDownItem,
  handleItemUpdate,
  handleDynamicFocus,
  handleDynamicBlur,
  handleDropdownClick,
  handleDropdownDynamicClick,
  handleFocusReset,
  setSubmitConfirm,
  submitConfirm,
  inputRefs,
  dynamicInputRef,
  handleSubmit,
  loading,
  modal_state,
}) => {
  // Add useEffect to focus on create_date when component loads
  useEffect(() => {
    if (inputRefs?.create_date?.current) {
      setTimeout(() => {
        inputRefs.create_date.current.focus();
        if (inputRefs.create_date.current.value) {
          inputRefs.create_date.current.setSelectionRange(0, inputRefs.create_date.current.value.length);
        }
      }, 100);
    }
  }, [inputRefs?.create_date]);

  const inputFields = [
    {
      label: "",
      name: "serial_no",
      type: "text",
      isRequired: true,
      isDisabled: true,
    },
    {
      label: "Date",
      name: "create_date",
      type: "text",
      isRequired: true,
      isDisabled: false,
    },
    {
      label: "Account",
      name: "account",
      type: "text",
      isRequired: true,
      isDisabled: false,
    },
    {
      label: "Narration",
      name: "narration",
      type: "text",
      isRequired: true,
      isDisabled: false,
    },
  ];

  const dropdownConfig = {
    account: {
      title: "List of Ledger",
      input_id: "account_ledger_id",
      data: contra_account_ledger_list,
    },
  };
  return (
    <Form
      handleSubmit={handleSubmit}
      handleKeyDown={handleKeyDown}
      submitConfirm={submitConfirm}
      handleFocusReset={handleFocusReset}
      title={"Accounting Voucher Creation"}
      loading={loading || loading_voucher}
      col="col-12"
      Footer={MasterCreationFooter}
    >
      <div className="row p-0 m-0 mb-1">
        <div className="col-6">
          <div className="d-flex justify-content-between align-item-center">
            <label className="lab_voucher_entry" style={{ width: "35%" }}>
              {data?.voucher_type_name} No
            </label>
            <label>:</label>
            {inputFields
              .slice(0, 1)
              .map(
                (
                  { label, name, type, isRequired, isDisabled, autoFocus },
                  index
                ) => (
                  <input
                    style={{ fontSize: 13, fontWeight: "bold", width: "100%" }}
                    type={type}
                    disabled={true}
                    name={name}
                    id={name}
                    value={data[name] || ""}
                    onChange={handleChange}
                    onKeyUp={handleChange}
                    onBlur={handleBlur}
                    onFocus={handleFocus}
                    isRequired={isRequired}
                    ref={inputRefs[name]}
                  />
                )
              )}
          </div>
        </div>
        <div className="col-6">
          <div className="row justify-content-end">
            <div className="col-6 d-flex justify-content-end">
              {inputFields
                .slice(1, 2)
                .map(({ label, name, type, isRequired, autoFocus }, index) => (
                  // <InputField
                  //   key={index}
                  //   lable={label}
                  //   type={type}
                  //   name={name}
                  //   value={data[name] || ""}
                  //   handleChange={handleChange}
                  //   handleBlur={handleBlur}
                  //   handleFocus={handleFocus}
                  //   isRequired={isRequired}
                  //   ref={inputRefs[name]}
                  //   autoFocus={autoFocus}
                  //   handleDropdownClick={handleDropdownClick}
                  // />
                  <>
                  <label className="pe-2">{data?.day_name}</label>
                  <input
                    style={{
                      fontSize: 13,
                      textAlign: "right",
                      fontWeight: "bold",
                      width: "38%",
                      paddingRight: "2px",
                    }}
                    type={type}
                    name={name}
                    value={data[name] || ""}
                    onChange={handleChange}
                    onKeyUp={handleChange}
                    onBlur={handleBlur}
                    onFocus={handleFocus}
                    isRequired={isRequired}
                    ref={inputRefs[name]}
                    autoFocus={autoFocus}
                  />
                  </>
                ))}
            </div>
          </div>
        </div>
        <div className="col-6">
          {inputFields
            .slice(2, 3)
            .map(({ label, name, type, isRequired, autoFocus }, index) => (
              <InputField
                key={index}
                lable={label}
                type={type}
                name={name}
                value={data[name] || ""}
                handleChange={handleChange}
                handleBlur={handleBlur}
                handleFocus={handleFocus}
                isRequired={isRequired}
                ref={inputRefs[name]}
                autoFocus={autoFocus}
                handleDropdownClick={handleDropdownClick}
              />
            ))}

          <div className="d-flex justify-content-between align-item-center">
            <label
              className="lab_voucher_entry text-muted"
              style={{ width: "75%" }}
            >
              Current Balance{" "}
            </label>
            <label className="lab_colun_voucher_entry"> :</label>
            <label
              style={{ textAlign: "left" }}
              className={`voucher_entry_account_input ${
                data?.account_ledger_balance < 0
                  ? "color_red ps-2"
                  : "text-muted ps-2"
              }`}
            >
              {data?.account_ledger_balance == 0.0 || data?.account_ledger_balance == null || data?.account_ledger_balance == undefined || data?.account_ledger_balance == "0.00" || data?.account_ledger_balance == "0" || data?.account_ledger_balance == ""
                ? ""
                : currencyFormate(data?.account_ledger_balance)}
              <span
                className={
                  data?.account_ledger_balance < 0
                    ? "color_red ps-1"
                    : "m-0 p-0 ps-1 text-muted"
                }
              >
                {data?.account_ledger_balance == 0.0 ||
                data?.account_ledger_balance == null ||
                data?.account_ledger_balance == undefined ||
                data?.account_ledger_balance == "0.00" ||
                data?.account_ledger_balance == "0" ||
                data?.account_ledger_balance == ""
                  ? ""
                  : data?.account_ledger_balance < 0
                  ? "Cr"
                  : "Dr"}
              </span>
            </label>
          </div>

          {Object.entries(dropdownConfig).map(
            ([key, config]) =>
              modal_state?.[key] && (
                <DropdownLayout_1
                  key={key}
                  title={config.title}
                  state={modal_state[key]}
                  data={data}
                  setData={setData}
                  input_value={data[key]}
                  input_key={key}
                  input_blc={"account_ledger_balance"}
                  input_id={config?.input_id}
                  rawData={config.data}
                  ref={inputRefs[key]}
                  inputRefs={inputRefs}
                  setSubmitConfirm={setSubmitConfirm}
                  handleDropdownClick={handleDropdownClick}
                />
              )
          )}
        </div>
      </div>
      {/* <div className="row p-0 m-0 mb-1 border_2_2px_top border_2_1px_bottom  heading_dyn_creation_data">
        <div
          className="col-4 p-0 m-0 ps-2 font_size font-weight-bold"
          style={{ textAlign: "left" }}
        >
          Particulars
        </div>
        <div
          className="col-6 p-0 m-0 font_size font-weight-bold"
          style={{ textAlign: "left" }}
        ></div>
        <div
          className="col-2 p-0 m-0 pe-1 font_size font-weight-bold "
          style={{ textAlign: "right" }}
        >
          Amount
        </div>
      </div> */}
      <TableHeader />
      <div
        className="row p-0 m-0"
        style={{ height: "60vh", overflowY: "scroll" }}
      >
        <div className="col-12 p-0 m-0">
          <VoucherContraInputRow
            setValueLoop={setData}
            valueLoop={data}
            handleChange={handleItemUpdate}
            handleFocus={handleDynamicFocus}
            handleBlur={handleDynamicBlur}
            handleDropdownDynamicClick={handleDropdownDynamicClick}
            inputRefs={dynamicInputRef}
            narr_ref={inputRefs}
            dropList={[
              { id: "ed", ledger_name: "End of List" },
              ...contra_account_ledger_list,
            ]}
          />
        </div>
      </div>
      {/* <div className="row p-0 m-0" style={{ height: 19.5 }}>
        <div
          className="col-3 lab_voucher_entry align-self-end text-end border-top border-bottom border-dark ms-auto"
          style={{ height: 19.5 }}
        >
          {data?.total_amount}
        </div>
      </div>

      <div className="row p-0 m-0">
        <div className="col-12 m-0 p-0 ps-1 text-start  border-dark">
          {inputFields
            .slice(3)
            .map(({ label, name, type, isRequired }, index) => (
              <div className="d-flex justify-content-between align-item-center">
                <label>{label} </label>
                <label>:</label>
                <textarea
                  style={{ height: "7.5vh" }}
                  key={index}
                  lable={label}
                  className="narration_input"
                  type={type}
                  name={name}
                  value={data[name] || ""}
                  onKeyUp={handleChange}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  isRequired={isRequired}
                  ref={inputRefs[name]}
                />
              </div>
            ))}
        </div>
      </div> */}

      <div className="row p-0 m-0" style={{ width: "100%" }}>
        <div className="col-6 m-0 p-0 ps-1 text-start  border-dark">
          {inputFields
            .slice(3)
            .map(({ label, name, type, isRequired }, index) => (
              <>
                <label>{label} </label>
                <div className="d-flex justify-content-between align-item-center">
                  <textarea
                    style={{ height: "7.5vh" }}
                    key={index}
                    lable={label}
                    className="narration_input"
                    type={type}
                    name={name}
                    value={data[name] || ""}
                    onKeyUp={handleChange}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    isRequired={isRequired}
                    ref={inputRefs[name]}
                  />
                </div>
              </>
            ))}
        </div>
        <Total_Amount_Row data={data} />
      </div>
    </Form>
  );
};

export default Contra;
